import { EventType } from '~/if/event/EventType';

/**
 * Event-type string values whose `EventType` enum key is marked deprecated (the generated
 * `DeprecatedEvt*` entries). These are retained for backward compatibility but should be
 * de-emphasized in the webhook registration picker so platforms don't pick them for new endpoints.
 */
export const DEPRECATED_EVENT_TYPES = new Set<string>(
  Object.entries(EventType)
    .filter(([key]) => key.startsWith('Deprecated'))
    .map(([, value]) => value)
);

/**
 * Returns true when an event id should be treated as deprecated in the picker.
 *
 * A concrete event id (e.g. `cards.card.created`) is deprecated when its enum entry is marked
 * deprecated. A wildcard (e.g. `cards.*`) is deprecated only when every concrete event it matches
 * is deprecated — a wildcard spanning both deprecated and current events (e.g. `decision.*`) is
 * not treated as deprecated.
 */
export const isEventTypeDeprecated = (eventId: string, eventTypes: string[]): boolean => {
  if (eventId.endsWith('.*')) {
    const prefix = eventId.slice(0, -1);
    const matched = eventTypes.filter((name) => name.startsWith(prefix));
    return matched.length > 0 && matched.every((name) => DEPRECATED_EVENT_TYPES.has(name));
  }
  return DEPRECATED_EVENT_TYPES.has(eventId);
};
